<template>
<!-- This example requires Tailwind CSS v2.0+ -->
<nav class="bg-white sm:py-3">
  <div class="mx-auto px-2 sm:px-6 lg:px-8">
    <div class="relative flex justify-between h-16">
      <div class="absolute inset-y-0 left-0 flex items-center sm:hidden">
        <!-- Mobile menu button -->
        <button 
          type="button" 
          @click="mobileMenuOpen = !mobileMenuOpen"
          class="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500" 
          aria-controls="mobile-menu" 
          aria-expanded="false"
        >
          <span class="sr-only">Open main menu</span>
          <component
            :is="mobileMenuOpen ? 'XIcon' : 'MenuIcon'"
            class="w-6 h-6"
          />
        </button>
      </div>
      <div class="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start">
        <router-link :to="{ name: 'Home' }" class="flex-shrink-0 flex items-center">
          <img class="block lg:hidden h-5 w-auto" src="../assets/TheTutorIndex-logo-horizontal.svg" alt="The Tutor Index">
          <img class="hidden lg:block h-5 w-auto" src="../assets/TheTutorIndex-logo-horizontal.svg" alt="The Tutor Index">
        </router-link>
        <div class="hidden sm:ml-6 sm:flex sm:items-center sm:space-x-8">
          <!-- Current: "border-indigo-500 text-gray-900", Default: "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700" -->
          <router-link
            v-for="link of navItems"
            :key="link.label"
            :to="link.to"
            class="border-transparent text-gray-500 inline-flex items-center px-1 pt-3 pb-2 border-b-2 text-sm font-medium hover:border-gray-300 hover:text-gray-700"
            active-class="border-blue-500 text-gray-900"
          >
            {{ link.label }}
          </router-link>
        </div>
      </div>
      <div class="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
        <!-- <button type="button" class="bg-white p-1 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
          <span class="sr-only">View notifications</span>
          <!- Heroicon name: outline/bell ->
          <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
          </svg>
        </button> -->

        <!-- Profile dropdown -->
        <div class="ml-3 relative">
          <div>
            <button 
              v-if="isLoggedIn"
              type="button" 
              @click="$router.push({ name: 'EditTutor' })"
              class="bg-white rounded-full flex text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" 
              id="user-menu-button" 
              aria-expanded="false" 
              aria-haspopup="true"
            >
              <span class="sr-only">Open user menu</span>
              <!-- <img class="h-8 w-8 rounded-full" src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt=""> -->
              <img v-if="userPhoto" :src="userPhoto" class="h-8 w-8 rounded-full" alt="">
              <span v-else class="relative block h-8 w-8 rounded-full overflow-hidden bg-gray-100">
                <svg class="h-full w-full text-gray-300" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                </svg>
              </span>
            </button>
            <div v-else class="flex items-center space-x-4 hidden sm:block">
              <router-link :to="{ name: 'SignIn' }" class="border-transparent text-gray-500 inline-flex items-center px-1 pt-3 pb-2 border-b-2 text-sm font-medium hover:border-gray-300 hover:text-gray-700">
                Sign In
              </router-link>
              <TailwindButton
                @click="$router.push({ name: 'BecomeATutor' })"
                size="small"
              >
                Become a Tutor
              </TailwindButton>
            </div>
          </div>

          <!--
            Dropdown menu, show/hide based on menu state.

            Entering: "transition ease-out duration-200"
              From: "transform opacity-0 scale-95"
              To: "transform opacity-100 scale-100"
            Leaving: "transition ease-in duration-75"
              From: "transform opacity-100 scale-100"
              To: "transform opacity-0 scale-95"
          -->
          <!-- <div 
            class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none hidden"
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="user-menu-button"
            tabindex="-1"
          >
            <!- Active: "bg-gray-100", Not Active: "" ->
            <a href="#" class="block px-4 py-2 text-sm text-gray-700" role="menuitem" tabindex="-1" id="user-menu-item-0">Your Profile</a>
            <a href="#" class="block px-4 py-2 text-sm text-gray-700" role="menuitem" tabindex="-1" id="user-menu-item-1">Settings</a>
            <a href="#" class="block px-4 py-2 text-sm text-gray-700" role="menuitem" tabindex="-1" id="user-menu-item-2">Sign out</a>
          </div> -->
        </div>
      </div>
    </div>
  </div>

  <!-- Mobile menu, show/hide based on menu state. -->
  <div 
    class="sm:hidden"
    :class="[mobileMenuOpen ? 'block' : 'hidden']"
    id="mobile-menu"
  >
    <div class="pt-2 pb-4 space-y-1">
      <!-- Current: "bg-indigo-50 border-indigo-500 text-indigo-700", Default: "border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700" -->
      <router-link
        v-for="link of navItems"
        :key="link.label"
        :to="link.to"
        class="block pl-3 pr-4 py-2 border-l-4 text-base font-medium border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700"
        active-class="bg-blue-50 border-blue-500 text-blue-700"
      >
        {{ link.label }}
      </router-link>
      <template v-if="!isLoggedIn">
        <router-link :to="{ name: 'SignIn' }" class="block pl-3 pr-4 py-2 border-l-4 text-base font-medium border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700">
          Sign In
        </router-link>
        <div class="pt-2 px-3">
          <TailwindButton
            @click="$router.push({ name: 'BecomeATutor' })"
            size="small"
            class="w-full"
          >
            Become a Tutor
          </TailwindButton>
        </div>
      </template>
    </div>
  </div>
</nav>
</template>
<script>
import { MenuIcon, XIcon } from '@vue-hero-icons/outline'
import TailwindButton from './TailwindButton.vue'

export default {
  components: {
    MenuIcon,
    XIcon,
    TailwindButton,
  },
  data() {
    return {
      mobileMenuOpen: false,
      navItems: [
        { label: 'Job Board', to: { name: 'JobBoard' } },
        { label: 'Find a Tutor', to: { name: 'SearchResults' } },
        { label: 'Articles', to: { name: 'Articles' } },
        // { label: 'Sign In', to: { name: 'SignIn' } },
      ]
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn
    },
    userPhoto() {
      return this.$store.getters.user?.Photo
    },
  }
}
</script>